import { FuncionalidadesGeral } from '../../../helpers/funcionalidades'
// Bug 856501: ícone do card alinhado ao Figma da página inicial.
import caixaEntradaIcon from '../../../images/icones-os033/caixa-entrada.png'

export const options = [
  {
    title: 'Caixa de entrada',
    icon: caixaEntradaIcon,
    description: 'Visualize e gerencie os registros recebidos na ouvidoria',
    route: '/caixa-entrada',
    order: 1,
    area: 'caixa_entrada',
    funcionalidade: FuncionalidadesGeral.caixaEntrada.consultar,
  },
]
